import React, { useState } from 'react';
import Modal from '../../../components/Modal/Modal';
import styles from './HomeMain.module.css';
import homeImgs from '../../../assets/homeInfo/homeImgs.js';
// import { useTranslation } from 'react-i18next';
import HomeDescriptionText from '../HomeDescriptionText';

const mainImg = {
  link: 'https://i.ibb.co/djLL5zf/4.jpg',
  alter: 'picture',
  year: '2021',
  size: '85 x 65 cm',
  status: 'For sale',
};

const HomeMain = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  // const { t, i18n } = useTranslation();

  const openModal = (image) => {
    setSelectedImage(image);
    setModalOpen(true);
    // document.body.styles.overflow = 'hidden';
    document.body.classList.add(styles['modal-open']);
  };

  const closeModal = () => {
    setSelectedImage(null);
    setModalOpen(false);
    // document.body.styles.overflow = 'auto';
    document.body.classList.remove(styles['modal-open']);
  };

  return (
    <div className={styles.main}>
      <HomeDescriptionText />
      {/* <p>{t('lang.homeTitle2')}</p> */}
      <div
        className={styles.mainImgBox}
        onClick={
          () => openModal(mainImg)
          // () => openModal('https://i.ibb.co/djLL5zf/4.jpg')
          // openModal('https://i.ibb.co/MMpS2b0/3.jpg')
          // openModal('https://i.ibb.co/fqrSd3Q/11.jpg')
          // openModal('https://i.ibb.co/rvFdmJD/architecture-3488306-1280.jpg')
        }
      >
        <img
          className={styles.mainImg}
          src="https://i.ibb.co/djLL5zf/4.jpg"
          // src="https://i.ibb.co/MMpS2b0/3.jpg"
          // src="https://i.ibb.co/fqrSd3Q/11.jpg"
          // src="https://i.ibb.co/rvFdmJD/architecture-3488306-1280.jpg"
          alt="1"
          border="0"
        />
      </div>

      <div className={styles.subImgContainer}>
        {homeImgs?.map((item, idx) => (
          <div
            className={styles.imgBox}
            key={idx}
            onClick={() => openModal(item)}
            // onClick={() => openModal(item.link)}
          >
            <img
              className={styles.img}
              src={item.link}
              alt={item.alter}
              border="0"
            />
          </div>
        ))}
      </div>

      <Modal
        isOpen={modalOpen}
        onClose={closeModal}
        selectedImage={selectedImage}
      />
      {/* {modalOpen && (
        <div className={styles.modal}>
          <div className={styles.modalContent}>
            <span className={styles.close} onClick={closeModal}>
              &times;
            </span>
            <img
              className={styles.modalImg}
              src={selectedImage}
              alt="Modal"
              border="0"
            />
          </div>
        </div>
      )}*/}
    </div>
  );
};

export default HomeMain;
